<div id="reset-password" fxLayout="column">
  <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div
      id="login-form"
      id="login-form"
      [class.mat-elevation-z2]="!isActive"
      [class.mat-elevation-z8]="isActive"
    >
      <div class="logo">
        <img
          src="../../assets/heartcare_logo.png"
          style="height: 100px; width: 100px"
        />
      </div>

      <div class="mat-display-2 title">HeartCare</div>

      <form name="resetForm" [formGroup]="resetForm" novalidate>
        <mat-form-field appearance="fill">
          <mat-label>New password</mat-label>
          <input
            matInput
            formControlName="new_password"
            type="password"
            [(ngModel)]="password"
            required
            maxlength="15"
          />
          <mat-hint *ngIf="resetForm.invalid">
            Min length 8, at least one digit, uppercase, lowercase and special
            character.</mat-hint
          >
          <mat-error *ngIf="resetForm.hasError('required', ['new_password'])"
            >Password is required.</mat-error
          >
          <!-- <mat-error *ngIf="resetForm.invalid">
            Min length 8, at least one digit, uppercase, lowercase and special
            character.</mat-error
          > -->
        </mat-form-field>

        <mat-form-field appearance="fill" style="margin-top: 16px">
          <mat-label>Confirm password</mat-label>
          <input
            matInput
            formControlName="confirm_new_password"
            type="password"
            [(ngModel)]="confirmPassword"
            required
            maxlength="15"
          />
          <mat-error
            *ngIf="resetForm.hasError('required', ['confirm_new_password'])"
            >Please confirm the password.</mat-error
          >
          <!-- <mat-error *ngIf="resetForm.hasError('pattern', ['confirm_new_password'])">
                              Min length 8, at least one digit, uppercase, lowercase and special character.</mat-error> -->
          <!-- <mat-error *ngIf="resetForm.hasError('passwordMatch', ['confirm_new_password'])">Password does not match.</mat-error> -->
        </mat-form-field>
        <span
          *ngIf="
            password !== confirmPassword &&
            resetForm.get('confirm_new_password')?.dirty &&
            !resetForm.hasError('required', ['confirm_new_password'])
          "
        >
          <div class="reset-display">Passwords do not match</div>
        </span>

        <button
          mat-raised-button
          color="accent"
          class="submit-button mat-body-1"
          aria-label="RESET"
          color="accent"
          [disabled]="
            disableButton || resetForm.invalid || password !== confirmPassword
          "
          (click)="reset_password()"
        >
          SAVE
        </button>
        <button
          mat-raised-button
          color="disabled"
          type="button"
          class="submit-button mat-body-1"
          (click)="cancel()"
        >
          CANCEL
        </button>
      </form>
    </div>
  </div>
</div>
